/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './listConvos.defs.js'
export * as $defs from './listConvos.defs.js'
